<div id="main-app-wrapper">
  @if (allowMimic) {
    <lib-amdocs-mimic />
  }

  <div class="toaster-wrapper">
    @for (toast of toasterService.toasts; track toast) {
    <ngb-toast class="position-absolute start-50 translate-middle-x" [header]="toast.header" [autohide]="true"
      [delay]="toast.delay || 15000" [class]="toast.toastClass">
      
      <div class="d-flex align-items-start toaster-body">
        
        @switch (toast.iconColor) {
        @case ('red') {
        <img src="./assets/icons/warning-red.svg" alt="Icon" class="me-2 cursor-pointer" />
        }
        @case ('green') {
        <img src="./assets/icons/warning-green.svg" alt="Icon" class="me-2 cursor-pointer" />
        }
        @case ('blue') {
        <img src="./assets/icons/warning-blue.svg" alt="Icon" class="me-2 cursor-pointer" />
        }
        @default {}
        }
    
        <span class="toast-body-text fw-medium">
          {{ toast.body }}
          <a *ngIf="toast.link" [href]="toast.link" target="_blank">link</a>
        </span>
    
        <button class="d-inline-flex align-self-center ms-3 reset-button" (click)="toasterService.clearToasts()">
          <img src="./assets/icons/cross.svg" alt="Icon" class="cursor-pointer me-2" />
        </button>
      </div>
    </ngb-toast> }
  </div>
  @if (appFinishedLoaded && !appError) {
    <router-outlet />
  }

  @if (appError) {
    <lib-amdocs-app-error />
  }
  @if (showPWAiosNotifications) {
    <lib-amdocs-pwa-ios-notification />
  }

  @if (showLoaderCount) {
    <lib-amdocs-app-loader />
  }
  <lib-amdocs-user-notify-alert #userNotifyAlert />

  <app-version-alert />

  @if (show401ErrorPopup) {
    <lib-amdocs-popup #error401popup (closeCallback)="show401ErrorPopup = false">
      <lib-amdocs-popup-message 
        (actionClicked)="error401popupClick()"
        [title]='amdocsContentConstants?.general?.defaultErrorTitle'
        [message]='amdocsContentConstants?.general?.sessionExpiredMessage' 
        [showHomeButton]="false" />
    </lib-amdocs-popup>
  }

  @if (debugApiErrors.length) {
    <lib-amdocs-popup #debugPopup (closeCallback)="debugApiErrors = []">
      @for (err of debugApiErrors; track err) {
        <div style="padding: 10px">
          <div style="text-align: left">code: {{err.code}}</div>
          <div style="text-align: left">message: {{err.message}}</div>
          <hr />
        </div>
      }
      <button class="btn primary" (click)="debugPopup.close()">close</button>
    </lib-amdocs-popup>
  }



  @if (showOnBoarding && !skipOnBoarding) {
    <app-on-boarding (skipCallback)="skip()"></app-on-boarding>
  }
</div>

<div id="main-wrapper-landscape-message">
  <lib-amdocs-landscape-view></lib-amdocs-landscape-view>
</div>
